import { AccessControlFeatureKey } from '@shared/constants/features.const';

export const REPORTS_FEATURES = [
  AccessControlFeatureKey.FtsReportsInfractions,
  AccessControlFeatureKey.ReportsDataLoss,
  AccessControlFeatureKey.ReportsEvents,
  AccessControlFeatureKey.ReportsOverspeed,
  AccessControlFeatureKey.ReportsTapeDiagram,
  AccessControlFeatureKey.ReportsInfractions,
  AccessControlFeatureKey.ReportsWorkedHours,
  AccessControlFeatureKey.ReportsDistance,
  AccessControlFeatureKey.ReportsSassmaq,
  AccessControlFeatureKey.ReportsTravels,
  AccessControlFeatureKey.TwentyFourHours,
  AccessControlFeatureKey.ReportsInfractionsBvdr2,
  AccessControlFeatureKey.ReportsWorkedHoursBvdr2,
  AccessControlFeatureKey.ReportsDriversWorkedHoursBvdr2,
  AccessControlFeatureKey.FleetManagementScheduledServices,
  AccessControlFeatureKey.FtsIssues,
  AccessControlFeatureKey.FtsRoute,
  AccessControlFeatureKey.FtsKm,
  AccessControlFeatureKey.FtsSpeedRpm,
  AccessControlFeatureKey.WorkedHours,
  AccessControlFeatureKey.FtsOverspeed,
  AccessControlFeatureKey.FtsBlockSiren,
  AccessControlFeatureKey.FleetManagementFuel,
  AccessControlFeatureKey.FleetManagementLicenseExpiration,
  AccessControlFeatureKey.FtsDataAExtraction,
  AccessControlFeatureKey.ContractManagement,
  AccessControlFeatureKey.FtsSpeedRpm,
] as const;
